import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { SharedLanguageService } from '@language';
import {
    DialogConfig,
    DialogRef,
    DialogStyle,
    DottedKey,
    MultiFormSelectOptions,
    ShDynamicDialogService,
    ThesaurusConceptReference
} from '@stylehaven/components';
import {
    ThesaurusTreeSelection,
    ThesaurusTreeSelectionMode
} from '../../common/entities/common/thesaurus-tree-selection.entity';
import {
    ThesaurusTreeDialogOutput,
    ThesaurusTreeDialogOutputSuccess
} from '../entities/thesaurus-suggestion-dialog.entity';
import { ThesaurusTreeDialogComponent } from '../thesaurus-tree-dialog/thesaurus-tree-dialog.component';

@Injectable({ providedIn: 'root' })
export class SharedDialogHelper {
    constructor(
        public dialogService: ShDynamicDialogService,
        public translateService: SharedLanguageService
    ) {}

    public openThesaurusTreeDialog(
        thesaurusDefDottedKey: DottedKey,
        selectionMode: ThesaurusTreeSelectionMode,
        multiSelect: boolean,
        canSubmitSuggestions: boolean,
        readonly: boolean,
        initialTags: MultiFormSelectOptions<ThesaurusConceptReference> = { options: [], isLiveData: false },
        initialSuggestions: string[] = [],
        allowEmptyResult: boolean = false
    ): Observable<ThesaurusTreeSelection> {
        const config: DialogConfig = {
            title: this.translateService.translate('thesaurus.thesaurus-tree-dialog.select-concepts', {
                multiple: multiSelect
            }),
            options: {
                style: DialogStyle.Wide
            },
            data: {
                yes: this.translateService.translate('actions.common.apply'),
                no: this.translateService.translate('actions.common.cancel'),
                thesaurusDefDottedKey: thesaurusDefDottedKey,
                selectMultiple: multiSelect,
                enableSuggestions: canSubmitSuggestions,
                selectionMode,
                initialTags,
                initialSuggestions,
                readonly,
                allowEmptyResult
            }
        };

        const ref: DialogRef<ThesaurusTreeDialogOutput> = this.dialogService.open(ThesaurusTreeDialogComponent, config);
        const thesaurusTreeSelection$: Observable<ThesaurusTreeSelection> = ref.afterClosed$.pipe(
            filter(
                (output: ThesaurusTreeDialogOutput): output is ThesaurusTreeDialogOutputSuccess =>
                    output.type === 'success' && output.hasOwnProperty('selection')
            ),
            map(output => output.selection)
        );

        return thesaurusTreeSelection$;
    }
}
